import { getApiBaseUrl, getApiKey } from 'fake-db/apiConfig'
import Mock from '../../mock'
import axios from 'axios.js'

const API_KEY = getApiKey()
const API_URL = `${getApiBaseUrl()}/catalog`

const extractData = (response) => {
    const {error, errorInfo, result, message, data} = response.data || {};
    if (error || result === 'error') {
        return {
            __error: true,
            error: error || 'Error Catalog Product Tags',
            errorInfo: errorInfo || message || 'Ошибка справочника отметок товаров',
            result: result || 'error',
        };
    }
    return Array.isArray(data) ? data : [];
};

const getAllProductTagsUser = async () => {
    const response = await axios.get(`${API_URL}/getAllProductTags/?apiKey=${API_KEY}`);
    return extractData(response);
};

const setActiveProductTag = async (id, val) => {
    const response = await axios.post(`${API_URL}/setProductTagActive/?apiKey=${API_KEY}`, {id, val});
    return extractData(response);
};

const setDeletedProductTag = async (id, val) => {
    const response = await axios.post(`${API_URL}/setProductTagDeleted/?apiKey=${API_KEY}`, {id, val});
    return extractData(response);
};

const setUpdateProductTag = async (dataProductTagUpdate) => {
    const response = await axios.post(`${API_URL}/setProductTagUpdate/?apiKey=${API_KEY}`, {dataProductTagUpdate});
    return extractData(response);
};

const setSaveNewProductTag = async (dataProductTagUpdate) => {
    const response = await axios.post(`${API_URL}/setSaveNewProductTag/?apiKey=${API_KEY}`, {dataProductTagUpdate});
    return extractData(response);
};

Mock.onGet('/api/catalog/getAllProductTags').reply(async () => {
    const productTags = await getAllProductTagsUser();
    if (productTags && productTags.__error) {
        return [400, productTags];
    }
    return [200, productTags || []];
})

Mock.onPost('/api/catalog/setActiveProductTag').reply(async (config) => {
    const {id, val} = JSON.parse(config.data || '{}');
    const productTags = await setActiveProductTag(id, val);
    return [200, productTags || []];
})

Mock.onPost('/api/catalog/setDeletedProductTag').reply(async (config) => {
    const {id, val} = JSON.parse(config.data || '{}');
    const productTags = await setDeletedProductTag(id, val);
    return [200, productTags || []];
})

Mock.onPost('/api/catalog/setUpdateProductTag').reply(async (config) => {
    const {dataProductTagUpdate} = JSON.parse(config.data || '{}');
    const productTags = await setUpdateProductTag(dataProductTagUpdate);
    return [200, productTags || []];
})

Mock.onPost('/api/catalog/setSaveNewProductTag').reply(async (config) => {
    const {dataProductTagUpdate} = JSON.parse(config.data || '{}');
    const productTags = await setSaveNewProductTag(dataProductTagUpdate);
    return [200, productTags || []];
})
